import * as allProducts from '@/mocks/data/catalogue/products/list'
import { user } from '@/mocks/data/general/user'
import * as allMachines from '@/mocks/data/machines/list'
import * as allSites from '@/mocks/data/park/sites/list'

import { newDateFormatted } from '@/utils/app/date'

import { Order, ReasonCancelOrder, StatusOrder } from '@/types/operations/order'

export const order1: Order = {
    id: 1,
    status: StatusOrder.enum.CANCELLED,
    site: allSites.site1,
    terminal: allMachines.machine1,
    reason: ReasonCancelOrder.enum.KONVIVE,
    konvive: user,
    price: 12,
    articles: [
        {
            product: allProducts.product1,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-2)}T11:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            changes: [
                {
                    product: allProducts.product1,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-2)}T11:30:00`,
            status: StatusOrder.enum.CANCELLED,
            changes: [],
        },
    ],
}

export const order2: Order = {
    id: 2,
    status: StatusOrder.enum.RETRIEVED,
    site: allSites.site1,
    terminal: allMachines.machine1,
    konvive: user,
    price: 11,
    articles: [
        {
            product: allProducts.product2,
            is_weight_quantity: true,
            quantity: 250,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-1)}T10:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            changes: [
                {
                    product: allProducts.product2,
                    is_weight_quantity: true,
                    quantity: 2_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-1)}T10:30:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T11:10:00`,
            status: StatusOrder.enum.READY,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T14:30:00`,
            status: StatusOrder.enum.RETRIEVED,
            changes: [],
        },
    ],
}

export const order3: Order = {
    id: 3,
    status: StatusOrder.enum.READY,
    site: allSites.site1,
    phone_number: '0645362718',
    price: 18,
    articles: [
        {
            product: allProducts.product1,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: allProducts.product2,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(0)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            changes: [
                {
                    product: allProducts.product1,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: allProducts.product2,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(0)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            changes: [
                {
                    product: allProducts.product1,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: allProducts.product2,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(0)}T10:30:00`,
            status: StatusOrder.enum.READY,
            changes: [],
        },
    ],
}

export const order4: Order = {
    id: 4,
    status: StatusOrder.enum.ON_DELIVERY,
    site: allSites.site1,
    phone_number: '0101010101',
    price: 15,
    articles: [
        {
            product: allProducts.product2,
            is_weight_quantity: true,
            quantity: 300,
        },
        {
            product: allProducts.product3,
            is_weight_quantity: true,
            quantity: 500,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(0)}T09:10:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            changes: [
                {
                    product: allProducts.product2,
                    is_weight_quantity: true,
                    quantity: 250,
                },
                {
                    product: allProducts.product3,
                    is_weight_quantity: true,
                    quantity: 250,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(0)}T10:10:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            changes: [],
        },
    ],
}
